import { fieldCannotBeEmpty, MAX_LENGTH, MIN_LENGTH } from 'constants/messages'

export const COMPANY_RULES = {
  name: {
    required: { value: true, message: fieldCannotBeEmpty },
    maxLength: {
      value: 36,
      message: MAX_LENGTH('Company name', 36),
    },
    minLength: {
      value: 1,
      message: MIN_LENGTH('Company name', 1),
    },
  },
  email: {
    required: { value: true, message: fieldCannotBeEmpty },
    pattern: {
      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: 'Invalid email address',
    },
  },
  logo: {
    required: { value: true, message: fieldCannotBeEmpty },
  },

  priceId: {
    required: { value: true, message: fieldCannotBeEmpty },
    pattern: {
      value: /^price_[a-zA-Z0-9]+$/,
      message: 'Invalid price ID',
    },
  },
}
